import {LocaleCode} from '../../../shared/locale/locales'
import {LinkResolver} from '../../../shared/types/link-resolver'
import localeCodeToUrl from '../../../shared/utils/locale-to-url'
import {removeTrailingSlash} from '../../../shared/utils/remove-trailing-slash'

export const linkResolver: LinkResolver = (doc) => {
    const localize = (path: string) =>
        removeTrailingSlash(
            `/${localeCodeToUrl(doc.lang as LocaleCode)}${path === '/' ? '' : path}`
        )

    switch (doc.type) {
        case 'homepage_v3': {
            return localize('/')
        }

        case 'homepage_v3_repeatable': {
            return localize(`/lp/${doc.uid}`)
        }

        case 'ebook': {
            return localize(`/ebooks/${doc.uid}`)
        }

        case 'ebook_marketing_download': {
            return localize(`/ebook/${doc.uid}`)
        }

        case 'partner_page': {
            return localize('/partners')
        }

        case 'event_bigform_page': {
            return localize('/bigform-event')
        }

        case 'fetch_page': {
            return localize('/fetch')
        }

        case 'integrations_index_page': {
            return localize('/integrations')
        }

        case 'integration_page': {
            return localize(`/integrations/${doc.uid}`)
        }

        case 'perks_page': {
            return localize('/perks')
        }

        case 'perks_internal_page': {
            return localize('/perks-internal')
        }

        case 'subscriptions_page': {
            return localize('/subscriptions')
        }

        case 'pricing_page': {
            return localize('/pricing')
        }

        case 'why_pleo_page': {
            return localize('/whypleo')
        }

        case 'customers_page': {
            return localize('/customers')
        }

        case 'about_us_page': {
            return localize('/about')
        }

        case 'careers_page': {
            return localize('/careers')
        }
        case 'expense_policy_builder': {
            return localize('/expense-policy-builder')
        }

        case 'roi_calculator': {
            return localize('/expense-report-roi-calculator')
        }

        case 'expense_report_generator': {
            return localize('/expense-report-generator')
        }

        case 'legal_page': {
            return localize('/legal')
        }

        case 'legal_page_gdpr': {
            return localize('/legal/gdpr')
        }

        case 'legal_page_cookie_policy': {
            return localize('/legal/cookie-policy')
        }

        case 'legal_page_third_party_licences': {
            return localize('/legal/third-party-licences')
        }

        case 'faq_page': {
            return localize('/faq')
        }

        case 'customer_case': {
            return localize(`/customer-cases/${doc.uid}`)
        }

        case 'partner': {
            return localize(`/partner/${doc.uid}`)
        }

        case 'fincircle_page': {
            return localize('/fincircle')
        }

        case 'not_found_page': {
            return localize('/404')
        }

        case 'youtube_homepage_landing': {
            return localize('/lp/yt')
        }

        case 'youtube_xero_landing': {
            return localize('/lp/yt/integrations/xero')
        }

        case 'bills_tracker': {
            return localize('/bills-tracker')
        }

        case 'bills_status': {
            return localize('/bills-status')
        }

        case 'expense_report_generator_external_variant': {
            return localize('/expense-report-generator-external')
        }

        case 'pre_launch_form_page': {
            return localize('/join-early')
        }

        case 'flex_benefits_page': {
            return localize('/careers/benefits')
        }

        case 'calendly_page':
        case 'demo_page':
        case 'bigform_page':
        case 'partner_bigform_page':
        case 'apple_pay_page':
        case 'slice_page':
        case 'experimental_landing_page':
        case 'wista_channel_page':
        case 'podcast_form_page': {
            return localize(`/${doc.uid}`)
        }

        default: {
            return 'UNKNOWN_DOCUMENT_TYPE'
        }
    }
}
